<template>
    <div
        class="DoubleSystemQuizView"
        @mousemove="drag"
        @mouseup="dragEnd"
        @mouseleave="dragEnd"
        @touchmove="drag"
        @touchend="dragEnd"
    >
        <div class="top-part-wrapper">
            <div class="progress-bar-wrapper">
                <div class="progress-bar" :style="{ width: percentageProgress + '%' }" />
            </div>

            <div class="exit-button-wrapper" @click="$router.go(-1)">{{ $t('systems.exit') }}</div>
            <h2>{{ $t('systems.instruction') }}</h2>
            <div class="drop-boxes">
                <div
                    v-for="number in matchBoxNumbers"
                    :key="number"
                    class="drop-box"
                    :number="number"
                    @mouseenter="iluminateTile"
                    @mouseleave="resetIluminationFromTile"
                >
                    <AnimatedNumbershape
                        v-if="matchedNumbers.includes(number)"
                        :number="number"
                        class="numbershape"
                        reversed
                    />
                    <p v-else> {{ number }} </p>
                </div>
            </div>
        </div>
        <div class="bottom-part-wrapper">
            <div v-if="stepItems.length" class="carousel-rail">
                <div
                    v-for="item in slideItems"
                    :key="item.number"
                    class="shape-wrapper"
                    @mousedown="e => dragStart(e, item.number)"
                    @touchstart="e => dragStart(e, item.number)"
                >
                    <AnimatedNumbershape :number="item.number" class="numbershape" reversed />
                </div>
            </div>
            <div v-if="carouselSlidesCount > 1" class="carousel-pagination">
                <div
                    v-for="i in carouselSlidesCount"
                    :key="i"
                    :class="{ active: i === carousel.activeSlideIndex + 1 }"
                    class="pagination-dot"
                    @click="carousel.activeSlideIndex = i - 1"
                />
            </div>
        </div>
    </div>
</template>

<script>
import AnimatedNumbershape from '@/components/AnimatedNumbershape';
import quizMixin from './quiz.mixin';
import dragAndDropMixin from './dragAndDrop.mixin';

export default {
    components: {
        AnimatedNumbershape
    },

    mixins: [quizMixin, dragAndDropMixin],

    data() {
        return {
            matchedNumbers: []
        };
    },

    computed: {
        stepItems: {
            get: function () {
                return this.step.items[this.currentLocale];
            },
            set: function (newArr) {
                this.step.items[this.currentLocale] = newArr;
            }
        }
    },

    mounted() {
        this.setMatchBoxesNumbers();
        this.shuffleItemsInArray(this.stepItems);
    },

    methods: {
        dragStart(e, number) {
            const dragItem = e.path.find(domElement => domElement.className === 'shape-wrapper');
            this.selectedItemNumber = number;

            if (e.type === 'touchstart') {
                this.dragAndDrop.initialX = e.touches[0].clientX;
                this.dragAndDrop.initialY = e.touches[0].clientY;
            } else {
                this.dragAndDrop.initialX = e.clientX;
                this.dragAndDrop.initialY = e.clientY;
            }

            this.dragAndDrop.active = true;
            this.dragAndDrop.dragItem = dragItem;

            this.setDraggedItemZIndex(10);
            this.setPointerEvent(false);
        },

        addItemIntoMatchingArea() {
            const matchArea = document.querySelector('.drop-boxes');
            const matchedTile = matchArea.querySelector(`.drop-box[number="${this.selectedItemNumber}"]`);

            matchedTile.style.border = 'none';
            this.matchedNumbers.push(this.selectedItemNumber);

            this.animateMatchedItem(matchedTile);
        }
    }
};
</script>

<style lang="scss" scoped>
.DoubleSystemQuizView {
    width: 375px;
    min-height: 809px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px;
    .progress-bar-wrapper {
        height: 10px;

        .progress-bar {
            transition: 0.5s;
            background: white;
            height: 100%;
            width: 0;
        }
    }
    .exit-button-wrapper {
        text-align: right;
        margin-top: 10px;
        color: hsla(0, 0%, 100%, 0.5);
    }
    h2 {
        font-size: 21px;
        font-weight: normal;
        text-align: center;
        margin-top: 30px;
    }
    .drop-boxes {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;
        .drop-box {
            min-width: 75px;
            min-height: 75px;
            max-width: 75px;
            max-height: 75px;
            border: 1px dashed hsla(0, 0%, 100%, 0.5);
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 22px;
            color: hsla(0, 0%, 100%, 0.5);
            margin: 7.5px;
            transition: 0.5s;
            .numbershape {
                width: 100%;
                height: 100%;
                border-radius: 10px;
                background-color: white;
            }
        }
    }
    .bottom-part-wrapper {
        position: relative;

        .carousel-rail {
            display: flex;
            background: hsla(0, 0%, 100%, 0.5);
            padding: 5px;
            margin-top: 20px;
            border-radius: 10px;
            height: 75px;
            .shape-wrapper {
                width: calc(20% - 5px);
                border-radius: 10px;
                margin-right: 5px;
                background-color: white;

                .numbershape {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .carousel-pagination {
            display: flex;
            justify-content: center;
            margin-top: 20px;
            .pagination-dot {
                width: 10px;
                height: 10px;
                background: hsla(0, 0%, 100%, 0.5);
                margin: 5px;
                border-radius: 50%;
                &.active {
                    background: white;
                }
            }
        }
    }
}
</style>
